'use strict';

angular.module('atex.dam').directive('damTextMining', [ '$translate', 'DamTextMiningModalController',
function($translate, DamTextMiningModalController) {
  return {
    restrict : 'EA',
    
    templateUrl : 'views/dam-textmining.html',
    
    replace : true,
    
    scope : {
      entries : "="
    },
    
    link : function(scope, element, attrs) {
      var obj = element.find('.form-control');

      obj.select2();
      var tags = [];
      if (scope.entries) {
        angular.forEach(scope.entries, function(entry, key) {
          if (entry !== null) {
            tags.push({
              id : entry.id,
              text : entry.name
            });
          }
        });
      }

      obj.select2('data', tags);
      obj.select2('disable', true);

      if ((scope.entries !== undefined) && (scope.entries.length !== undefined) && (scope.entries.length > 0)) {
        angular.forEach(scope.entries, function(entry, key) {
          if (entry.attributes !== undefined && entry.attributes !== null) {
            var obj = element.find('.select2-search-choice').find('div').filter(function() {
              return $(this).text() === entry['@name'];
            });

            obj.parent().addClass('selected_clr');
            obj.click(function() {
              var info = {};
              angular.forEach(entry.attributes.attribute, function(attribute, key) {
                info[attribute.name] = attribute.value;
              });

              var confirmModal = DamTextMiningModalController.create({
                'header' : 'Additional Information',
                'close' : $translate.getTranslationTable()['CLOSE_BUTTON_'],
                'url' : info
              });
            });
          }
        });
      } else if ((scope.entries !== undefined) && (scope.entries.attributes !== undefined) && (scope.entries.attributes !== null)) {
        element.find('.select2-search-choice').addClass('selected_clr');
        
        element.find('.select2-search-choice').click(function() {
          var info = {};
          angular.forEach(scope.entries.attributes.attribute, function(attribute, key) {
            info[attribute.name] = attribute.value;
          });

          var confirmModal = DamTextMiningModalController.create({
            'header' : 'Additional Information',
            'close' : $translate.getTranslationTable()._CLOSE_BUTTON_,
            'url' : info
          });
        });
        
      }
    }
    
  };
} ]);
